import FooterNavbar from "../../../../footernavbar/FooterNavbar";
import AboutusNavbar from "../AboutusNavbar";

const CorporateInfo = () => {
  return (
    <>
      <div className=" display-max">
        <FooterNavbar />
        <AboutusNavbar />
        <div>
          <div className="py-4">
            <div className="row">
              <div className="col-lg-12 justify-content-center text-center ">
                <span className="badge badge-md rounded-pill badge-warning text-capitalize text-white mb-2">
                  Corporate Information
                </span>
                <h1 className=" text-black source-serif-4 text-normal mt-2 lh-2">
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                  Empowering innovation through strategic collaboration <br />{" "}
                  and transformative solutions.{" "}
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                </h1>
              </div>
            </div>
            <div className="w-60 h-50 mx-auto mt-4">
              <div className="d-block blur-shadow-image">
                <img
                  src="../../assets/img/footer/corpinfo-1.jpeg"
                  alt="img-blur-shadow-blog-2"
                  className="img-full "
                  loading="lazy"
                />
              </div>
            </div>
          </div>
          <div className="row w-70 d-flex justify-content-center mx-auto">
            <section className="py-5">
              <div className="container">
                <div className="row align-items-center">
                  <div className="container col-lg-10  col-md-6 position-relative mb-sm-0 mb-3">
                    <hr className="vertical dark d-md-block d-none" />
                    <h1 className="mb-3 text-black  fw-bold">About Us</h1>
                    <p className="mb-3 fs-4 text-black">
                      Welcome to Sworld solutions private limited, where
                      innovation meets excellence in the world of online
                      shopping. Founded in 2020, we are an emerging ecommerce
                      company with a mission to redefine the online retail
                      experience. Our goal is to provide our customers with
                      high-quality products, exceptional service, and a seamless
                      shopping experience that exceeds their expectations.{" "}
                    </p>
                  </div>
                  <div className="col-lg-2 col-md-6 position-relative mb-sm-0 mb-1">
                    <div className="mb-4">
                      <h1 className="text-normal text-black">
                        2020
                        <p className="mb-3 fs-5 text-black">founded</p>
                      </h1>
                    </div>
                    <div className="mb-4">
                      <h1 className="text-normal text-black">
                        15
                        <p className="mb-3 fs-5 text-black">humans</p>
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="py-5">
              <div className="container align-items-center">
                <div className="row">
                  <div className="col-lg-7 col-md-12">
                    <div className="p-3 pt-0">
                      <h2 className="mb-3 text-black fw-bold">Our Story</h2>
                      <p className="mb-3 fs-4 text-black">
                        Sworld was born out of a passion for delivering
                        outstanding products and a commitment to customer
                        satisfaction. Our founders, Suraj Ahmed , saw an
                        opportunity to create a company that combines
                        cutting-edge technology with a customer-centric
                        approach. With backgrounds in Masters in Computer
                        Science, they brought together a team of talented
                        individuals who share their vision and drive.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-5 col-md-8">
                    <div className="position-relative ms-md-0 h-100">
                      <img
                        src="../../assets/img/footer/corporateInfoimag-1.jpeg"
                        className="border-radius-xl position-absolute"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="py-7">
              <div className="container">
                <div className="row">
                  <div className="col-lg-5 col-md-8">
                    <div className="position-relative ms-md-0 h-100">
                      <img
                        src="../../assets/img/footer/corporateinfoimage-2.jpeg"
                        className="w-100 border-radius-xl position-absolute"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-lg-7 col-md-12">
                    <div className="p-3 pt-0">
                      <h2 className="mb-3 text-black fw-bold">Our Mission</h2>
                      <p className="mb-3 fs-4 text-black">
                        Our mission is to revolutionize ecommerce by offering a
                        diverse range of high-quality products that enhance our
                        customers' lives. We strive to build a brand that is
                        synonymous with trust, innovation, and excellence. By
                        putting our customers at the center of everything we do,
                        we aim to create lasting relationships and a loyal
                        community of satisfied shoppers.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section>
              <h1 className=" text-black source-serif-4 text-normal text-center mb-6">
                Our Values
              </h1>
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-lg-7">
                    <div className="row justify-content-start">
                      <div className="col-md-6">
                        <div className="info">
                          <i className="ri-earth-fill text-3xl text-gradient text-info mb-3"></i>
                          <h3 className="text-normal source-serif-4 text-black">
                            Quality
                          </h3>
                          <p className="fs-5 text-black">
                            We believe in offering only the best. From sourcing
                            premium materials to implementing rigorous quality
                            control processes, we ensure that every product
                            meets our high standards of excellence.
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="info">
                          <i className="ri-bank-card-fill text-3xl text-gradient text-info mb-3"></i>
                          <h3 className="text-normal source-serif-4 text-black">
                            Innovation
                          </h3>
                          <p className="fs-5 text-black">
                            Innovation is at the heart of our company. We
                            embrace new ideas, technologies, and approaches to
                            continually improve our products and services. Our
                            forward-thinking mindset keeps us ahead of industry
                            trends and drives our growth.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row justify-content-start mt-4">
                      <div className="col-md-6">
                        <div className="info">
                          <i className="ri-grid-fill text-3xl text-gradient text-info mb-3"></i>
                          <h3 className="text-normal source-serif-4 text-black">
                            Integrity
                          </h3>
                          <p className="fs-5 text-black">
                            We conduct our business with the highest ethical
                            standards. Transparency, honesty, and integrity
                            guide our interactions with customers, employees,
                            and partners. We believe in doing the right thing,
                            even when no one is watching.
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="info">
                          <i className="ri-chat-heart-fill text-3xl text-gradient text-info mb-3"></i>
                          <h3 className="text-normal source-serif-4 text-black">
                            Sustainability
                          </h3>
                          <p className="fs-5 text-black">
                            We are committed to sustainable practices that
                            minimize our environmental impact. From eco-friendly
                            materials to responsible production methods, we
                            strive to make a positive difference for the planet.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 ms-auto mt-lg-0">
                    <div className="card">
                      <div className="card-header p-0 position-relative mt-n6 mx-1 z-index-2">
                        <div className="d-block blur-shadow-image">
                          <img
                            src="../../assets/img/footer/customer-focus.jpeg"
                            alt="img-colored-shadow"
                            className="img-fluid border-radius-lg"
                          />
                        </div>
                      </div>
                      <div className="card-body text-center">
                        <h5 className="font-weight-normal">
                          <a href=",">Customer Focus</a>
                        </h5>
                        <p className="mb-0 fs-4 text-black text-start">
                          Our customers are our top priority. We are dedicated
                          to understanding their needs and delivering products
                          and services that exceed their expectations. Every
                          decision we make is driven by our commitment to
                          customer satisfaction.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container mt-0 pt-5">
                <div className="row">
                  <div className="col-lg-6 justify-content-center d-flex flex-column">
                    <div className="card">
                      <div className="d-block blur-shadow-image">
                        <img
                          src="../../assets/img/footer/Products-Image.jpeg"
                          alt="img-blur-shadow-blog-2"
                          className="img-fluid border-radius-lg"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 justify-content-center d-flex flex-column pl-lg-5 pt-lg-0">
                    <h2 className="mb-3 text-black fw-bold">Our Products</h2>
                    <p className="mb-3 p-0 fs-4 container text-black">
                      At Sworld, we offer a curated selection of products that
                      cater to a wide range of needs and preferences. Our
                      diverse product categories include Electronics, clothing,
                      groceries and garments etc.. and Services like Travel
                      Industry, Fashion & Entertainment Industry, each designed
                      to enhance your everyday life. We take pride in our
                      rigorous selection process, ensuring that every item in
                      our store meets our high standards of quality,
                      functionality, and style.
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div>
            <div className="row py-5">
              <div className="container">
                <div className="col-lg-12 justify-content-center text-center ">
                  <span className="badge rounded-pill badge-success text-white text-capitalize mb-3">
                    Our Team
                  </span>
                  <h4 className=" text-black source-serif-4 text-normal mt-2">
                    <sup>
                      {" "}
                      <i
                        className="ri-double-quotes-l text-dark text-5xl"
                        aria-hidden="true"
                      ></i>{" "}
                    </sup>
                    Our team is our greatest asset. Comprised of passionate,
                    driven, and creative individuals, <br /> we work
                    collaboratively to achieve our goals. Our diverse
                    backgrounds and expertise enable us to innovate and deliver
                    exceptional products and services. <br /> At Sworld , we
                    foster a culture of inclusivity, respect, and continuous
                    learning, empowering our team members to reach their full
                    potential.{" "}
                    <sup>
                      {" "}
                      <i
                        className="ri-double-quotes-r text-dark text-5xl"
                        aria-hidden="true"
                      ></i>{" "}
                    </sup>
                  </h4>
                </div>
              </div>
            </div>
            <div className="w-50 mx-auto mt-4">
              <div className="d-block blur-shadow-image">
                <img
                  src="../../assets/img/footer/corporate-team.jpg"
                  alt="img-blur-shadow-blog-2"
                  className="img-full "
                  loading="lazy"
                />
              </div>
            </div>
          </div>
          <section className="py-8 position-relative">
            <div className="container-fluid">
              <div className="row">
                <div className="col-10 mx-auto bg-gradient-dark border-radius-lg">
                  <div className="row py-5">
                    <div className="col-xl-3 col-md-6 px-5 position-relative">
                      <img
                        className="img border-radius-md max-width-300 w-100 position-relative z-index-2 mt-n7"
                        src="https://images.unsplash.com/photo-1521668576204-57ae3afee860?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=934&q=80"
                        loading="lazy"
                        alt=""
                      />
                    </div>
                    <div className="col-xl-8 col-md-5 z-index-2 position-relative px-md-3 px-5 my-md-auto mt-4">
                      <div className="d-flex justify-content-center text-center">
                        <h2 className="text-white source-serif-4 text-normal mt-0 mb-3">
                          <sup>
                            <i
                              className="ri-double-quotes-l text-white text-5xl"
                              aria-hidden="true"
                            ></i>{" "}
                          </sup>
                          Join Us on Our Journey
                          <sup>
                            {" "}
                            <i
                              className="ri-double-quotes-r text-white text-5xl"
                              aria-hidden="true"
                            ></i>{" "}
                          </sup>
                        </h2>
                      </div>
                      <p className="text-lg text-white">
                        As an emerging ecommerce startup, we are excited about
                        the future and the opportunities ahead. We invite you to
                        join us on our journey as we continue to grow, innovate,
                        and redefine the online shopping experience. Whether
                        you're a customer, partner, or prospective employee, we
                        look forward to building a lasting relationship with
                        you.
                      </p>
                      <hr className="vertical start-100 ms-n5 d-xl-block d-none" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default CorporateInfo;
